var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 27.2142C18.3632 27.2142 17.4922 26.3432 17.4922 25.2699V19.4385C17.4922 18.3652 18.3632 17.4941 19.4366 17.4941C20.5099 17.4941 21.381 18.3652 21.381 19.4385V25.2699C21.381 26.3432 20.5099 27.2142 19.4366 27.2142Z",
    fill: "#FF4800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4366 11.6621C18.3632 11.6621 17.4922 12.5332 17.4922 13.6065C17.4922 14.6798 18.3632 15.5509 19.4366 15.5509C20.5099 15.5509 21.381 14.6798 21.381 13.6065C21.381 12.5332 20.5099 11.6621 19.4366 11.6621Z",
    fill: "#FF4800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.4383C0 8.70313 8.70313 0 19.4383 0C30.1736 0 38.8767 8.70313 38.8767 19.4383C38.8767 30.1736 30.1736 38.8767 19.4383 38.8767C8.70313 38.8767 0 30.1736 0 19.4383ZM19.4383 3.88879C10.85 3.88879 3.88879 10.85 3.88879 19.4383C3.88879 28.0267 10.85 34.9879 19.4383 34.9879C28.0267 34.9879 34.9879 28.0267 34.9879 19.4383C34.9879 10.85 28.0267 3.88879 19.4383 3.88879Z",
    fill: "#FF4800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCardLogo);
export default __webpack_public_path__ + "static/media/help-card-logo.f1d22d9dfe04bab14ec8b547d749bed1.svg";
export { ForwardRef as ReactComponent };